<template>
  <!-- 用户管理-用户禁止操作-投诉支付用户记录弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="投诉支付用户记录"
      width="800px"
      @close="closeDialog"
    >
      <header>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-input
              v-model="query.user_id"
              placeholder="请输入用户UID"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getData()"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </header>
      <!-- body内容 -->
      <div class="body-box">
        <el-table
          :data="dataList"
          v-loading="loading"
          max-height="500px"
          style="margin-bottom: 20px"
        >
          <el-table-column prop="user_id" label="用户id" align="center">
          </el-table-column>
          <el-table-column prop="type" label="禁止类型">
            <template slot-scope="{ row }">
              <span v-if="row.type === 'complaintPayUser'">投诉支付用户</span>
              <span v-if="row.type === 'forbidRechargeTips'"
                >禁止充值（特殊提示）</span
              >
              <span v-if="row.type === 'forbidRecharge'">禁止充值</span>
              <span v-if="row.type === 'prizeRecharge'">黑名单用户</span>
              <span v-if="row.type === 'forbidTackOut'">禁止取回</span>
              <span v-if="row.type === 'deliverySMS'">禁止发送短信</span>
              <span v-if="row.type === 'pullNewSecondKill'">禁止秒杀活动</span>
              <span v-if="row.type === 'rollUser'">roll房展示用户</span>
              <span v-if="row.type === 'onceTradeLink'">特殊账号交易链接</span>
              <span v-if="row.type === 'rechargeShowType'">仅展示中兴支付</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350px">
            <template slot-scope="{ row }">
              <el-row>
                <el-button type="danger" @click="handleDelete(row.id)"
                  >删除
                </el-button>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :total="dataMeta ? dataMeta.total : 0"
          :current-page="dataMeta ? dataMeta.current_page : 1"
          :page-size="dataMeta ? dataMeta.per_page : 15"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      lock: false,//加锁
      query: {
        page: 1,
        user_id: ''
      },
      dataList: undefined,//数据列表
      dataMeta: undefined, //表格数据列表
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogData: {
      get() {
        return this.value
      },
      set() {
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    },
  },
  created() {
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData(`user_forbid_record`, params).then((res) => {
        this.dataList = res.data
        this.dataMeta = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`user_forbid_record/${id}`).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    // 底部分页
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>